import Styles from './styles.module.css';
import React, { useState } from 'react';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { TbNumber1Small, TbNumber2Small, TbNumber3Small, TbNumber4Small, TbNumber5Small, TbNumber6Small, TbNumber7Small, TbNumber8Small } from 'react-icons/tb';
import { PiCheckCircleFill } from 'react-icons/pi';
import { VscChevronRight } from 'react-icons/vsc';

// 中途採用「求人の編集」用のセクション切替ナビゲーション。
// 新卒側(3.recruit/navigation)と違い、searchIndex登録・学校送付は行わない。
// 「公開」ボタンは recruitStatus を 1 にするだけ(アプリ掲載等の仕組みは別途検討)。

export const MID_CAREER_RECRUIT_SECTIONS = [
  "店舗概要",
  "募集店舗",
  "会社の魅力3選",
  "数字で見る",
  "写真で見る",
  "インタビュー",
  "求める人物像",
  "応募設定",
];

const numberIcons = [
  <TbNumber1Small className={Styles.nav_number} />,
  <TbNumber2Small className={Styles.nav_number} />,
  <TbNumber3Small className={Styles.nav_number} />,
  <TbNumber4Small className={Styles.nav_number} />,
  <TbNumber5Small className={Styles.nav_number} />,
  <TbNumber6Small className={Styles.nav_number} />,
  <TbNumber7Small className={Styles.nav_number} />,
  <TbNumber8Small className={Styles.nav_number} />,
];

type MidCareerRecruitNavigationProps = {
  progress: boolean[];
  changeData: boolean;
  navigation: number;
  setNavigation: React.Dispatch<React.SetStateAction<number>>;
  setBackCaution: React.Dispatch<React.SetStateAction<number>>;
  documentId: string;
  published: boolean;
};

const MidCareerRecruitNavigation: React.FC<MidCareerRecruitNavigationProps> = ({
  progress, changeData, navigation, setNavigation, setBackCaution, documentId, published,
}) => {
  const db = getFirestore();
  const [uploading, setUploading] = useState(false);

  const allCompleted = progress.length > 0 && progress.every(Boolean);

  const publicDoc = async () => {
    if (!documentId) return;
    setUploading(true);
    try {
      await updateDoc(doc(db, 'recruits', documentId), { recruitStatus: 1 });
    } catch (error) {
      console.error('中途採用求人の公開に失敗しました:', error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className={Styles.navigation}>
      <h4 className={Styles.navigation_title}>求人の編集(中途)</h4>

      {MID_CAREER_RECRUIT_SECTIONS.map((label, index) => {
        const num = index + 1;
        const isActive = navigation === num;
        const isCompleted = progress[num - 1];

        return (
          <div className={Styles.navigation_item}
            key={num}
            onClick={() => (changeData && navigation !== num ? setBackCaution(num) : setNavigation(num))}
            style={{ backgroundColor: isActive ? "#EBEBEB" : "" }}>
            <p>
              {numberIcons[index]}
              {label}
            </p>

            {isCompleted ? (
              <PiCheckCircleFill className={Styles.save} />
            ) : (
              <VscChevronRight className={Styles.unSave} />
            )}
          </div>
        );
      })}

      {published ? (
        <span className={Styles.chip_published}>
          <PiCheckCircleFill className={Styles.save} />公開済み
        </span>
      ) : (
        <button
          type="button"
          className={Styles.save_btn}
          disabled={!allCompleted || uploading}
          onClick={publicDoc}
        >
          {uploading ? '公開中...' : '公開'}
        </button>
      )}
    </div>
  );
};

export default MidCareerRecruitNavigation;
